module.exports = __webpack_public_path__ + "img/t4-p3.393b70a3.png";